import { useStore } from 'effector-react';
import { FormField, TextInput } from 'evergreen-ui';
import { styled } from 'linaria/react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import key from 'src/assets/key.png';
import mail from 'src/assets/mail.png';
import surprise from 'src/assets/surprise.png';
import { AuthButton, AuthContainer, AuthForm, AuthFormTitle, AuthHint, ForgotLink } from 'src/features/auth/ui/components';
import { routes } from 'src/routes';
import { createResetCodeFx, resetPasswordFx } from 'src/store/user.store';

const Surprise = styled.div`
	text-align: center;
  margin-bottom: 20px;

	img {
		max-width: 100px;
	}
`;
const Icon = styled.span`
	img {
		max-width: 16px;
    opacity: .3;
    margin-right: -28px;
    filter: invert(1);
	}
`;

export const ForgotPassword = () => {
	const [code, updateCode] = useState<string | null>(null);
	const [email, updateEmail] = useState('');
	const [password, updatePassword] = useState('');
	const resetLoading = useStore(resetPasswordFx.pending)

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const value = params.get('code');
		if (value) {
			updateCode(value);
		}
	}, []);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!code) {
			createResetCodeFx({ email });
		} else {
			resetPasswordFx({ code, password });
		}
	};

	return (
		<>
			<AuthContainer>
				<AuthForm onSubmit={handleSubmit}>
					<Surprise>
						<img src={surprise} alt=""/>
					</Surprise>
					<AuthFormTitle>Reset password</AuthFormTitle>
					{code ? (
						<>
							<FormField
								style={{ marginTop: 10, marginLeft: 15, marginRight: -15 }}
								className={'inputstyle-auth'}
							>
								<Icon>
									<img src={key} alt=""/>
								</Icon>
								<TextInput
									required
									width={'100%'}
									type={'password'}
									placeholder={'New Password'}
									value={password}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => updatePassword(e.target.value)}

								/>
							</FormField>
							<AuthButton onClick={handleSubmit}>
								Save
							</AuthButton>
						</>
					) : (
						<>
							<p style={{ fontSize: 15 }}>To reset your password, please provide your email</p>
							<FormField
								style={{ marginTop: 30, marginLeft: 15, marginRight: -15 }}
								className={'inputstyle-auth'}
							>
								<Icon>
									<img src={mail} alt=""/>
								</Icon>
								<TextInput
									required
									value={email}
									placeholder={'E-mail'}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateEmail(e.target.value)}
									width={'100%'}
									type={'email'}
								/>
								<AuthButton>
									Send Reset Instructions
								</AuthButton>
							</FormField>
						</>
					)}
					<AuthHint>
						Already have an account? <Link to={routes.root.auth.login.path}>Sign in here</Link>
					</AuthHint>
				</AuthForm>
			</AuthContainer>
		</>
	);
};
